// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FEGH","left":"styles_left__1bXV7","desktopActions":"styles_desktopActions__zAAOM","title":"styles_title__3vN0G"};